import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

export default WithDirection(styled.div`
    height: 100%;

    .flag-select {
        margin: 0; margin-left: 7px;
        height: 100%;
        border-right: 1px solid rgba(151, 151, 151, 1);
        padding: 0; padding-right: 7px;
    }
    .flag-select * { top: unset; right: unset; bottom: unset; left: unset; }

    .flag-select > * {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        height: 100%;
        padding: 0;
    }
    .flag-select > * > * { display: inline-block; height: auto !important; }

    .flag-select .country-flag { display: inline-flex; align-items: center; min-width: 65px; }
    .flag-select .country-flag img { width: 24px; height: auto; }
    .flag-select .country-flag img ~ * { padding-left: 4px; }

    .flag-select .flag-options {
        justify-content: flex-start;
        left: 8px;
        margin-top: -4px;
        display: block;
        width: 110%;
        max-height: unset;
        height: auto;
    }
    .flag-select .flag-options .has-label {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0;
        padding: 0 7px;
        min-height: 35px;
        overflow-x: hidden;
    }

    @media screen and (max-width: 767px) {
        .flag-select .country-flag { min-width: 40px;}
        .flag-select .country-flag img { width: 20px; }
        .flag-select .country-flag img ~ * { padding-left: 2px; }
    }
`);


// WEBPACK FOOTER //
// ./src/components/SearchAppBar/FlagWrapper.js